import { createApp, h } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createBootstrap } from "bootstrap-vue-next";

import ConcertRequestCalendarPage from "./page/ConcertRequestCalendarPage.vue";

import { roomBookingQueryClient, initUrlConfig } from "../../room-booking-management/api";

$(document).ready(function () {
    if (!/\/event-management\/concert-request-calendar\/\d+$/.test(window.location.pathname)) {
        return;
    }

    const container = $("#vue-container");
    if (!container.length) {
        console.error("Concert request calendar container not found");
        return;
    }

    const config = {
        roomId: parseInt(container.data("roomId")),
        roomName: container.data("roomName"),
        roomBookingApiUrl: container.data("roomBookingApiUrl"),
        userApiUrl: container.data("userApiUrl"),
        concertRequestCalendarApiUrl: container.data("concertRequestCalendarApiUrl"),
    };

    if (!config.roomId || !config.roomBookingApiUrl || !config.userApiUrl || !config.concertRequestCalendarApiUrl) {
        console.error("Missing required configuration for concert request calendar page", config);
        return;
    }

    initUrlConfig({
        userApiUrl: config.userApiUrl,
        roomBookingApiUrl: config.roomBookingApiUrl,
    });

    const app = createApp(
        {
            render() {
                return h(ConcertRequestCalendarPage, config);
            },
            props: [
                "roomId",
                "roomName",
                "roomBookingApiUrl",
                "userApiUrl",
                "concertRequestCalendarApiUrl",
            ],
        },
        config
    );

    app.use(VueQueryPlugin, { queryClient: roomBookingQueryClient });
    app.use(createBootstrap());

    app.mount(container[0]);
});